import React from 'react';
import { Icon } from '@iconify/react';

export const PerformanceVisual = () => {
  return (
    <div className="relative w-full h-full flex items-center justify-center">
        {/* Background Grid */}
        <div className="absolute inset-4 grid grid-cols-4 gap-2 opacity-20 pointer-events-none">
            {[...Array(8)].map((_, i) => (
                <div key={i} className="bg-gray-100 rounded h-full w-full"></div>
            ))}
        </div>

        {/* Main Chart Card */}
        <div className="bg-white w-48 p-3 rounded-xl shadow-lg border border-gray-50 relative z-10 transition-transform hover:-translate-y-1">
            <div className="flex justify-between items-center mb-3">
                <div className="text-[10px] font-bold text-gray-700">Sentiment Analysis</div>
                <div className="text-[9px] text-green-500 flex items-center gap-0.5 bg-green-50 px-1.5 py-0.5 rounded-full font-medium">
                    <Icon icon="mdi:trending-up" width={8} /> +98% Positive
                </div>
            </div>

            {/* Bar Chart Bars */}
            <div className="flex items-end gap-1.5 h-12 mb-1">
                <div className="w-full bg-gray-100 rounded-t-sm h-[40%]"></div>
                <div className="w-full bg-gray-100 rounded-t-sm h-[60%]"></div>
                <div className="w-full bg-pink-200 rounded-t-sm h-[30%]"></div>
                <div className="w-full bg-gray-100 rounded-t-sm h-[70%]"></div>
                <div className="w-full bg-gradient-to-t from-pink-500 to-purple-500 rounded-t-sm h-[90%] shadow-lg shadow-pink-200/50"></div>
                <div className="w-full bg-gray-100 rounded-t-sm h-[50%]"></div>
            </div>
        </div>

        {/* Auto Reply Bubble Pop-up */}
        <div
            className="absolute -right-2 bottom-8 bg-blue-100 text-blue-900 px-3 py-2 rounded-xl rounded-bl-none shadow-xl flex items-center gap-2 z-20 cursor-default hover:bg-blue-200 transition-colors border border-blue-200"
            style={{
                animation: 'gentlePulse 3s ease-in-out infinite'
            }}
        >
            <Icon icon="mdi:message-reply" width={12} className="text-blue-600" />
            <div className="flex flex-col">
                <span className="text-[8px] opacity-70 uppercase tracking-wider font-semibold">AI Auto Reply</span>
                <span className="text-[10px] font-medium">"Thanks for your support!"</span>
            </div>
        </div>
    </div>
  );
};

export default PerformanceVisual;
